// extracted by mini-css-extract-plugin
module.exports = {"alerta":"Error_alerta__2iwgF"};